const routes = {
  login: {
    root: "/login",
  },
  homePage: {
    homePage: "/homePage",
  },
  customerOrders: {
    customerOrders: "/customerOrders",
  },
  orderDetails: {
    orderDetails: "/orderDetails",
  }
};

export default routes;
